import React, { useState } from "react";
import BocomboTask from "./BocomboTask";
import {
  DndContext, 
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

const BocomboList = ({
  list,
  handleToggle,
  handleDelete,
  editTask,
  handleSorting
}) => {
  const [items, setItems] = useState(list.map(task => task.id));

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  function handleDragEnd(event) {
    const {active, over} = event;
    
    if (active.id !== over.id) {
      const oldIndex = items.indexOf(active.id);
      const newIndex = items.indexOf(over.id);
      const mapped = arrayMove(items, oldIndex, newIndex);
      setItems(mapped);
      handleSorting(mapped);
    }
  }

  return (
    <div className="listOuter">
      <div className="listInner">
        <DndContext 
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext 
            items={items}
            strategy={verticalListSortingStrategy}
          >
            {list.map(task => <BocomboTask
                  task={task}
                  handleToggle={handleToggle}
                  handleDelete={handleDelete}
                  editTask={editTask}
                  key={task.id + "task"}
                />)}
          </SortableContext>
        </DndContext>
      </div>
    </div>
  );
};

export default BocomboList;
